import { render } from "./TwoFactorVerification.vue?vue&type=template&id=890bbfb8&scoped=true"
import script from "./TwoFactorVerification.vue?vue&type=script&lang=js"
export * from "./TwoFactorVerification.vue?vue&type=script&lang=js"

import "./TwoFactorVerification.vue?vue&type=style&index=0&id=890bbfb8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890bbfb8"]])

export default __exports__